import Banner from './banner.vue';
export default Banner;